/**
 * 0: 院内処方
 * 1: 院外処方
 * 2: オンライン薬局
 */
export var IsInpatientPrescription;
(function (IsInpatientPrescription) {
    IsInpatientPrescription[IsInpatientPrescription["Inpatient"] = 0] = "Inpatient";
    IsInpatientPrescription[IsInpatientPrescription["Outpatient"] = 1] = "Outpatient";
    IsInpatientPrescription[IsInpatientPrescription["Online"] = 2] = "Online";
})(IsInpatientPrescription || (IsInpatientPrescription = {}));
/**
 * 1: au
 * 2: kiviaq
 */
export var OnlinePharmacy;
(function (OnlinePharmacy) {
    OnlinePharmacy[OnlinePharmacy["AU"] = 1] = "AU";
    OnlinePharmacy[OnlinePharmacy["Kiviaq"] = 2] = "Kiviaq";
})(OnlinePharmacy || (OnlinePharmacy = {}));
